import { render } from "./FinishedTest.vue?vue&type=template&id=4b8b93b2&scoped=true"
const script = {}

import "./FinishedTest.vue?vue&type=style&index=0&id=4b8b93b2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tests-frontend/tests-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b8b93b2"]])

export default __exports__